import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import Hero from '../components/Hero';
import FeaturedProjects from '../components/FeaturedProjects';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import { Star, Quote, ArrowRight, Users, Award, Clock, CheckCircle, MapPin, Home } from 'lucide-react';
import { projectsData } from '@/mockData';

const HomePage = () => {
  const statsRef = useRef(null);
  const [startCounter, setStartCounter] = useState(false);

  const stats = [
    { icon: <Award className="w-8 h-8 text-yellow-500" />, number: 200000, suffix: "+", label: "Sq.Ft Area Delivered" },
    { icon: <Clock className="w-8 h-8 text-yellow-500" />, number: 20, suffix: "+", label: "Years Experience" },
    { icon: <Users className="w-8 h-8 text-yellow-500" />, number: 200, suffix: "+", label: "Happy Clients" },
    { icon: <CheckCircle className="w-8 h-8 text-yellow-500" />, number: 25, suffix: "+", label: "Projects done" },
  ];

  // Updated useCounter hook to reset when not visible
  const useCounter = (end, duration = 2000, start = false) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!start) {
        setCount(0); // reset counter if section not visible
        return;
      }

      let startVal = 0;
      const increment = end / (duration / 30);

      const timer = setInterval(() => {
        startVal += increment;
        if (startVal >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.ceil(startVal));
        }
      }, 30);

      return () => clearInterval(timer);
    }, [end, duration, start]);

    return count;
  };

  // Intersection Observer to detect visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCounter(true); // section visible → animate
        } else {
          setStartCounter(false); // section hidden → reset
        }
      },
      { threshold: 0.3 } // 30% visible
    );

    if (statsRef.current) observer.observe(statsRef.current);

    return () => {
      if (statsRef.current) observer.unobserve(statsRef.current);
    };
  }, []);

  return (
    <div className="min-h-screen text-gray-900">
      <Hero />
      <AboutSection />

      {/* Current Projects */}

      <section className="relative py-4 sm:py-8 md:py-8 lg:py-12 text-center bg-gradient-to-br">
        <div
          className="container mx-auto px-4 sm:px-6 md:px-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.6 }}
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.2 }
            }
          }}
        >
          {/* Luxury Heading */}
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-2 text-['#011321']">Current Projects</h2>
          <p className="text-lg max-w-2xl text-center mx-auto mb-12 leading-relaxed text-gray-600">
            Building your vision with precision and care. From concept to creation, we deliver structures that stand the test of time.
          </p>


          {/* Description */}
          <p
            className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-600 mb-6 sm:mb-8 md:mb-10 leading-relaxed max-w-4xl mx-auto"
          >
          </p>

          {/* Gold underline accent */}
          <span className="block w-24 sm:w-32 md:w-40 lg:w-48 h-0.5 sm:h-1 mx-auto bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-600 rounded-full shadow-md"></span>
        </div>
      </section>

      {/* first side */}
      <section className="flex flex-col lg:flex-row">
        {/* Left Side: Image */}
        <div className="w-full lg:w-1/2 h-64 sm:h-80 md:h-96 lg:h-auto">
          <img
            src="/images/secondProject.jpg"
            alt="Gaurav Square"
            className="w-full h-full object-cover xs:object-fill md:object-cover"
          />
        </div>

        {/* Right Side: Text */}
        <div className="w-full lg:w-1/2 flex flex-col justify-center p-4 sm:p-6 md:p-8 lg:p-12 bg-gray-400">
          {/* <h3
            style={{ fontFamily: '"Dancing Script", cursive' }}
            className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-extrabold mb-2 sm:mb-3 md:mb-4 
           bg-gradient-to-r from-yellow-400 via-yellow-200 to-white 
           bg-clip-text text-transparent drop-shadow-2xl tracking-wide text-center lg:text-center leading-tight"
          >
            "Prajakta La Maison"
          </h3> */}
          <div className="flex justify-center">
            <img
              src="/La-maison-gallary/la-massion-name.png"
              alt="Prajakta La Maison"
              className="w-64 h-30 object-contain m-0 p-0 contrast-150 drop-shadow-md "
            />
          </div>

          {/* Small Tagline */}
          <p
            style={{ fontFamily: 'Julee, cursive' }}
            className="text-sm sm:text-base md:text-lg font-medium text-gray-100 italic text-center mb-4 sm:mb-6 tracking-wide">
            <q> French Soul Indian heart</q>
          </p>

          <p className="mb-3 sm:mb-4 md:mb-5 text-sm sm:text-base md:text-lg lg:text-lg leading-relaxed text-gray-800 font-serif italic tracking-wide">
            Madhuprabha Constructions Pvt. Ltd. is proud to present <span className="font-bold">Prajakta La Maison</span>,
            a gold green certified residential building based on European theme. Experience Ultra Luxurious european elegance at strategic location at pandey layout, Nagpur
          </p>

          {/* <p className="mb-3 sm:mb-4 md:mb-5 text-sm sm:text-base md:text-lg lg:text-lg leading-relaxed text-gray-800 font-serif italic tracking-wide">
            Here every movement feels like a Parisian escape.
            Live in a home where every day is a celebration of charm.
          </p> */}
          {/* <p

            className="text-sm sm:text-base md:text-lg font-medium text-gray-100 italic text-center mb-4 sm:mb-6 tracking-wide">
            <q> Live a la francaise -- the French way of Life.</q>
          </p> */}
          {/* {projectsData.map((project, index) => ( */}
          <div className="text-center mt-4 sm:mt-6">
            <Link
              to={`/project/1`} // navigate to the specific project page
              className="inline-flex items-center px-6 py-1 bg-gradient-to-r from-[#011321] to-[#03365f] text-white text-lg font-semibold rounded-full shadow-lg hover:scale-105 duration-200 transition-all"
            >
              Explore Project
              <span className="ml-2">&rarr;</span>
            </Link>
          </div>
          {/* ))} */}


          <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6"></span>
        </div>
      </section>


      <section className="flex flex-col lg:flex-row ">
        {/* Left Side: Text */}
        <div className="w-full lg:w-1/2 flex flex-col justify-center p-4 sm:p-6 md:p-8 lg:p-12 bg-gray-400 order-2 lg:order-1">
          {/* <h3
            style={{ fontFamily: '"Dancing Script", cursive' }}
            className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-extrabold mb-4 sm:mb-6 md:mb-8 
                 bg-gradient-to-r from-yellow-400 via-yellow-200 to-white 
                 bg-clip-text text-transparent drop-shadow-2xl tracking-wide text-center lg:text-center leading-tight">
            "Prajakta Park"
          </h3> */}
          <div className="flex justify-center">
            <img
              src="/prajkata-park-name-leaf.png"
              alt="Prajakta La Maison"
              className="w-40 h-20 object-contain m-0 p-0 contrast-150 drop-shadow-md"
            />
            
          </div>


          {/* Small Tagline */}
          <p className="text-sm sm:text-base md:text-lg font-medium text-gray-100 italic text-center mb-4 sm:mb-6 tracking-wide">
            {/* <q>A Perfect harmony of nature, comfort and modern living</q> */}
            <q>Here comfort meets quality and transparency</q>
          </p>


          <p className="mb-3 sm:mb-4 md:mb-5 text-sm sm:text-base md:text-lg lg:text-lg leading-relaxed text-gray-800 font-serif italic tracking-wide">
            <span className="font-semibold">Prajakta Park</span> – Park facing apartments thoughtfully designed residential project that blends nature with modern living. Prajakta Park offers spacious homes surrounded by greenery, ensuring peace and comfort in every corner. With premium amenities, excellent connectivity, and a vibrant community, it is the perfect place to create memories and celebrate life every day.
          </p>
          {/* 
          <p className="mb-4 sm:mb-6 md:mb-8 text-sm sm:text-base md:text-lg lg:text-xl max-w-none lg:max-w-3xl mx-auto lg:mx-0 leading-relaxed text-black/90 font-light drop-shadow-lg text-center lg:text-left">
            The additional advantage of the project is its location. You can easily access many things like Shopping Mall, Inox, Metro Station, Hospital, Petrol Pump, ATM etc. within walking distance.
            <strong>"Gaurav Euphoria"</strong> is the perfect place to live a luxurious life, that you can call a dream home.
          </p> */}

          {/* Small Tagline */}
          {/* <p className="text-sm sm:text-base md:text-lg font-medium text-gray-100 italic text-center mb-4 sm:mb-6 tracking-wide">
            <q>Here comfort meets quality and transparency</q>
          </p> */}

          {/* {projectsData.map((project, index) => ( */}
          <div className="text-center mt-4 sm:mt-6">
            <Link
              to={`/project/2`} // navigate to the specific project page
              className="inline-flex items-center px-6 py-1 bg-gradient-to-r from-[#011321] to-[#03365f] text-white text-lg font-semibold rounded-full shadow-lg hover:scale-105 duration-200 transition-all"
            >
              Explore Project
              <span className="ml-2">&rarr;</span>
            </Link>
          </div>
          {/* ))} */}
          {/* Accent underline */}
          <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto  lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6"></span>
        </div>

        {/* Right Side: Image */}
        <div className="w-full lg:w-1/2 h-64 sm:h-80 md:h-96 lg:h-auto order-1 lg:order-2">
          <img
            src="images/MP_02.png"
            alt="Building"
            className="w-full h-full object-fill xs:object-fill md:object-cover"
          />
        </div>
      </section>



      {/* <section className="bg-[#1e3c72b5] py-16"> */}
      {/* <section className="bg-[#1e3c721a] py-16">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-2 text-['#011321']">Current Projects</h2>
        <p className="text-lg max-w-2xl text-center mx-auto mb-12 leading-relaxed text-gray-600">
          Building your vision with precision and care. From concept to creation, we deliver structures that stand the test of time.
        </p>

        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-8">
   
          <div className="relative group rounded-2xl overflow-hidden shadow-lg h-[400px]">
            <img
              src="/images/MP_02.png"
              alt="Prajakta Park"
              className="w-full h-full object-fill transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/80 flex flex-col justify-center items-center text-center text-white px-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
              <h3 className="text-2xl font-bold mb-2 text-['#011321']">Prajakta Park</h3>
              <p className="text-sm leading-relaxed mb-3 max-w-md">
                A thoughtfully designed residential project blending nature with modern living. Spacious homes surrounded by greenery.
              </p>
              <div className="flex items-center space-x-2 text-sm mb-1">
                <MapPin className="w-4 h-4 text-white" />
                <span>Abhyankar Nagar, Nagpur</span>
              </div>
              <div className="flex items-center space-x-2 text-sm">
                <Home className="w-4 h-4 text-['#fff']" />
                <span>Residential</span>
              </div>
            </div>
          </div>

    
          <div className="relative group rounded-2xl overflow-hidden shadow-lg h-[400px]">
            <img
              src="/images/secondProject.jpg"
              alt="Prajakta La Maison"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/80 flex flex-col justify-center items-center text-center text-white px-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
              <h3 className="text-2xl font-bold mb-2 text-['#011321']">Prajakta La Maison</h3>
              <p className="text-sm leading-relaxed mb-3 max-w-md">
                A 7-level luxurious 3 & 4 BHKD apartment located in the lap of nature. Peaceful mornings in the heart of the city with blissful greenery.
              </p>
              <div className="flex items-center space-x-2 text-sm mb-1">
                <MapPin className="w-4 h-4 text-white" />
                <span>Pandey Layout</span>
              </div>
              <div className="flex items-center space-x-2 text-sm">
                <Home className="w-4 h-4 text-['#fff']" />
                <span>Residential</span>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Statistics Section */}
      <section className="relative bg-white py-20" ref={statsRef}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#011321] mb-4">Statistics</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Strength, Quality, and Trust in Every Structure — showcasing our experience and satisfied clients.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
            {stats.map((counter, index) => {
              const count = useCounter(counter.number, 2000, startCounter);
              return (
                <div
                  key={index}
                  className="relative flex flex-col items-center p-8 bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-transform transform hover:-translate-y-2 border-8 border-gray-200"
                >
                  <div className="absolute -top-6 w-16 h-16 bg-gray-800 text-white rounded-full flex items-center justify-center text-3xl shadow-lg">
                    {counter.icon}
                  </div>
                  <div className="mt-12 text-center">
                    <span className="text-3xl md:text-4xl font-extrabold text-[#011321]">
                      {count}{counter.suffix}
                    </span>
                    <p className="mt-2 text-gray-600 text-sm md:text-base font-medium">
                      {counter.label}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* <FeaturedProjects /> */}
      <Footer />
    </div>
  );
};

export default HomePage;
